export const DEPOSIT_USER_RELEVO_ID = 'deposit';
